const initialState = {
    user: null
};

// eslint-disable-next-line default-param-last
export default function apiListReducer(state = initialState, action) {
    switch (action.type) {
        case 'GET_USER':
            state.enterpeise = action.data;
            return { ...state };
        default:
            return state;
    }
}
